import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class companyRelationsCtrl {
  /* @ngInject */
  constructor(
    $scope,
    logger,
    $translate,
    PRINCIPAL,
    KISS_SELLER,
    CompanyService,
    PrincipalSvc,
    CompanyRelationFilter,
    CompanyRelation,
    $window
  ) {
    this.$scope = $scope;
    this.logger = logger;
    this.$translate = $translate;
    this.PRINCIPAL = PRINCIPAL;
    this.KISS_SELLER = KISS_SELLER;
    this.CompanyService = CompanyService;
    this.PrincipalSvc = PrincipalSvc;
    this.CompanyRelationFilter = CompanyRelationFilter;
    this.CompanyRelation = CompanyRelation;
    this.$window = $window;
  }

  $onInit() {
    // ---------------
    // Data API
    // ---------------
    this.relations = _.map(this.pageRelations.content, r => {
      return new this.CompanyRelation(r);
    });
    this.dematModeList = this.PRINCIPAL.dematModes;
    this.ladTypesList = this.PRINCIPAL.searchableLadTypes;
    this.statusList = this.getStatusList();
    this.searchOpen = true;
    this.searchData = new this.CompanyRelationFilter();

    this.preparedSearchFilter = {};
    this.headers = [];

    // Liste
    var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
    this.gridOptions = {
      columnDefs: [
        {
          name: 'seller.legalEntity.getIdentifiant()',
          displayName: 'kiss_company_relation.list.seller_id',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'seller.legalEntity.getCountryLabel()',
          displayName: 'kiss_company_relation.list.country',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'seller.legalEntity.name',
          displayName: 'kiss_company_relation.list.seller_name',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'seller.getStatusLabel()',
          displayName: 'kiss_company_relation.list.status',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'getLadType()',
          displayName: 'kiss_company_relation.list.lad_type',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'getAllowedTransmissions()',
          displayName: 'kiss_company_relation.list.trans_mode',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'getAllowedDemats()',
          displayName: 'kiss_company_relation.list.demat_mode_list',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'getDematMode()',
          displayName: 'kiss_company_relation.list.demat_mode',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'creationDate',
          displayName: 'kiss_company_relation.list.creation',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          cellFilter: "date: 'shortDate'"
        },
        {
          name: 'acceptation',
          displayName: 'kiss_company_relation.list.acceptation',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          cellFilter: "date: 'shortDate'"
        },
        {
          name: 'endOfValidity',
          displayName: 'kiss_company_relation.list.validity',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          cellFilter: "date: 'shortDate'"
        }
      ],
      exporterOlderExcelCompatibility: true,
      useExternalPagination: true,
      useExternalSorting: true,
      onRegisterApi: gridApi => {
        this.gridApi = gridApi;
        // Sorting & pagination
        gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
          sortColumns = _.map(sortColumns, col => this.convertSort(col));
          if (sortColumns && sortColumns.length > 0) {
            this.searchData.setSort(sortColumns);
          } else {
            this.searchData.resetSort();
          }
          this.search();
        });
        gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
          this.searchData.setPageSize(size);
          this.searchData.setPage(page - 1);
          this.search();
        });
      },
      enableSorting: false,
      enableGridMenu: false,
      data: this.relations,
      enableColumnMenus: false,
      totalItems: this.pageRelations.totalElements
    };

    //initialiser le filtre de recherche pour l'export
    this.preparedSearchFilter = this.searchData.preparBeforeSearch();

    //recuperer la liste des headers pour l'export
    this.headers = _.map(this.gridOptions.columnDefs, 'displayName');
    this.headers = _.map(this.headers, column => {
      return this.$translate.instant(column);
    });
  }

  convertSort(col) {
    var columnField = _.find(this.KISS_SELLER.relation.columnFieldMap, { field: col.field });
    if (col && col.sort) {
      return {
        direction: angular.uppercase(col.sort.direction),
        property: columnField ? columnField.property : col.field,
        priority: col.sort.priority
      };
    }
    return {};
  }

  paginationChanged(page, size) {
    this.searchData.setPageSize(size);
    this.searchData.setPage(page - 1);
    this.search();
  }

  searchCompanies(value) {
    if (value && value.length >= 3) {
      return this.PrincipalSvc.searchCompanies(value).then(companies => {
        return companies;
      });
    }
  }

  search() {
    this.searchData.principal = this.PrincipalSvc.getPrincipal() ? this.PrincipalSvc.getPrincipal().detail : null;
    var filter = this.searchData.preparBeforeSearch();
    this.CompanyService.searchRelations({ companyId: this.companyInfo.id }, filter).$promise.then(
      pageRelations => {
        this.gridOptions.data = _.map(pageRelations.content, r => {
          return new this.CompanyRelation(r);
        });
          //enregistrer le filtre de recherche formaté pour l'export
          this.preparedSearchFilter = this.searchData.preparBeforeSearch();
          this.gridOptions.totalItems = pageRelations.totalElements;
      },
      (/*error*/) => {
        this.logger.error('error.search');
      }
    );
  }

  clearForm() {
    // Reset data
    this.searchData = new this.CompanyRelationFilter();
    // Reset form
    this.form.$setPristine();
    // Recherche
    this.search();
  }

  /**
   * Fournit la liste de statuts possibles.
   */

  getStatusList() {
    var slist = _.map(this.KISS_SELLER.seller.status, 'value');
    slist.splice(0, 0, 'ALL');
    return slist;
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight(gridApi) {
    return gridHeight(gridApi);
  }

  back() {
    this.$window.history.back();
  }
}

angular.module('app.principal').component('companyRelations', {
  templateUrl: require('./company-relations.html'),
  controller: companyRelationsCtrl,
  bindings: {
    principalInfo: '<',
    countries: '<',
    pageRelations: '<',
    companyInfo: '<'
  }
});
